import * as React from 'react';
import { FC } from 'react';
import money from 'app/helpers/money';
import useBonus, { RawStats } from './useBonus';

const WageringBonuses: FC<RawStats & { locales: Record<string, string>; currency: string }> = (props) => {
  const { requirements, bonus, pendingCount, wagerLeft, wagerPercentage } = useBonus(props);
  const { locales, currency } = props;

  const progress = () => (
    <div className="progress">
      <span className="wagered_prc">{wagerPercentage}%</span>
      <span className="requirements">{money(wagerLeft, currency)}</span>
      <div className="required_bar">
        <div className="wagered_bar" style={{ width: `${wagerPercentage}%` }} />
      </div>
    </div>
  );

  const activate = () => (
    <a className="activate" href="/bonuses">
      <span>{locales.activate_large}</span>
    </a>
  );

  if (bonus > 0 && requirements > 0) {
    return progress();
  }
  if (pendingCount > 0) {
    return activate();
  }
  return <div />;
};

export default WageringBonuses;
